import report from "./report.component";
import reportUrls from "./report.urls";
import ReportTransforms from "./report.transforms";

const reportModule = angular
  .module("app.components.report", [])
  .component("reportPage", report)
  .service("ReportTransforms", ReportTransforms)
  .config(reportUrls);

export default reportModule;



// WEBPACK FOOTER //
// ./src/pages/report/report.module.js